import { render } from "./TopLevelNotification.vue?vue&type=template&id=122f7082&scoped=true"
import script from "./TopLevelNotification.vue?vue&type=script&lang=js"
export * from "./TopLevelNotification.vue?vue&type=script&lang=js"

import "./TopLevelNotification.vue?vue&type=style&index=0&id=122f7082&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122f7082"]])

export default __exports__